import api from "./axios";

class ServiceCheckBank {
  async save(bank) {
    const { data } = await api.post("/check-banks", bank);
    return data;
  }

  async update(bank) {
    await api.put(`/check-banks/${bank.id}`, bank);
  }

  async delete(id) {
    await api.delete(`/check-banks/${id}`);
  }

  async findById(id) {
    const { data } = await api.get(`/check-banks/${id}`);
    return data;
  }

  async findAll() {
    const { data } = await api.get("/check-banks");
    return data;
  }
}

export default new ServiceCheckBank();
